export class ApprovePatient{
    "studyId":any;
    "visitId":any;
    "doctorId":any;
    "patientId":any;
    "doctorRemarks":any;
}